import React from 'react';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { ProgressBar } from 'primereact/progressbar';
import { Finding } from '@/api/domains/analyses/types';
import { FindingCard } from './FindingCard';
import styles from './FindingsSidebar.module.css';

interface FindingsSidebarProps {
  findings: Finding[];
  currentIndex: number;
  viewedFindings: Set<string>;
  isCollapsed: boolean;
  onNavigate: (index: number) => void;
  onToggleCollapse: () => void;
}

export const FindingsSidebar = ({
  findings,
  currentIndex,
  viewedFindings,
  isCollapsed,
  onNavigate,
  onToggleCollapse
}: FindingsSidebarProps) => {
  const reviewedCount = viewedFindings.size;
  const totalCount = findings.length;
  const progressPercentage = (reviewedCount / totalCount) * 100;

  if (isCollapsed) {
    return (
      <div className={styles.sidebarCollapsed}>
        <Button
          icon="pi pi-angle-right"
          onClick={onToggleCollapse}
          className={styles.expandButton}
        />
        <div className={styles.collapsedInfo}>
          <Badge
            value={totalCount}
            className={styles.collapsedTotalCount}
            severity="info"
          />
          <span className={styles.collapsedLabel}>Findings</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <div className={styles.headerTop}>
          <h3 className={styles.sidebarTitle}>
            Findings
            <Badge
              value={totalCount}
              severity="info"
              className={styles.countBadge}
            />
          </h3>
          <Button
            icon="pi pi-angle-left"
            onClick={onToggleCollapse}
            className={styles.collapseButton}
          />
        </div>

        <div className={styles.progressSection}>
          <div className={styles.progressLabel}>
            <span className={styles.progressText}>Reviewed</span>
            <span className={styles.progressNumbers}>
              {reviewedCount}/{totalCount}
            </span>
          </div>
          <ProgressBar
            value={progressPercentage}
            showValue={false}
            className={styles.progressBar}
          />
        </div>
      </div>

      <div className={styles.findingsList}>
        {findings.map((finding, index) => (
          <FindingCard
            key={finding.finding_id}
            finding={finding}
            isActive={index === currentIndex}
            isViewed={viewedFindings.has(finding.finding_id)}
            isCollapsed={false}
            onClick={() => onNavigate(index)}
          />
        ))}
      </div>
    </div>
  );
};
